import * as React from 'react';
import { cn } from '@/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-[84px] w-full resize-y rounded-lg border border-input bg-background px-3 py-2 text-base leading-relaxed text-foreground transition-[border-color,box-shadow] duration-150 outline-none placeholder:text-subtle hover:border-border-strong disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
